import request from '../../utils/request';

const BASE_URL = process.env.REACT_APP_EXPRESS_URL;
const URL = BASE_URL + '/statuses';

class Api {
  static async getAll() {
    const response = await request('get', URL);
    return response.data;
  }
}

export default Api;
